var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('a-header'),_c('p',[_vm._v("TODO")]),_c('a-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }